module.exports = __webpack_public_path__ + "img/top-bg.daf23ab7.png";